import {
  deleteMartialAttack,
  putMartialAttack,
} from "@/common/character/martialAttack";
import {
  convertAttacks,
  convertAttackSkills,
  convertRollString,
  convertAttacksBack,
  convertAttackSkillsBack,
  convertRollStringBack,
} from "@/common/general/convert";

export interface MartialAttack {
  name: string;
  mpCount: number;
  attacks: [any];
  attackSkills: [any];
  rollString: [any];
  description: string;
  id: number;
}

export interface MartialAttackStore {
  attacks: any[];
}

export default {
  namespaced: true,
  state: (): MartialAttackStore => ({
    attacks: [],
  }),
  getters: {
    martialAttacks: (state: MartialAttackStore) => {
      return state.attacks;
    },
  },
  mutations: {
    addMartialAttack: (state: MartialAttackStore, attack: MartialAttack) => {
      state.attacks.push(attack);
    },
    removeMartialAttack: (
      state: MartialAttackStore,
      name: { name: string }
    ) => {
      for (let i = 0; i < state.attacks.length; i++) {
        if (state.attacks[i].name === name.name) {
          state.attacks.splice(i, 1);
          break;
        }
      }
    },
    setMartialAttacks: (
      state: MartialAttackStore,
      attacks: [MartialAttack]
    ) => {
      state.attacks = attacks;
    },
  },
  actions: {
    removeMartialAttack: (
      context: any,
      newData: {
        characterId: string;
        name: string;
        mpCount: number;
        attacks: [any];
        attackSkills: [any];
        rollString: [any];
        description: string;
        id: number;
      }
    ) => {
      context.commit("removeMartialAttack", {
        name: newData.name,
      });
      const attacks = convertAttacks({ attacks: newData.attacks });
      const attackSkills = convertAttackSkills({
        attackSkills: newData.attackSkills,
      });
      const rollString = convertRollString({
        rollString: newData.rollString,
      });
      const attack = {
        characterId: newData.characterId,
        name: newData.name,
        mpCount: newData.mpCount,
        attacks: attacks,
        attackSkills: attackSkills,
        rollString: rollString,
        description: newData.description,
        id: newData.id,
      };
      deleteMartialAttack(attack);
    },
    updateMartialAttack: (
      context: any,
      newData: {
        character_id: string;
        name: string;
        mpCount: number;
        attacks: [any];
        attackSkills: [any];
        rollString: [any];
        description: string;
        id: number;
      }
    ) => {
      const attacks = convertAttacks({ attacks: newData.attacks });
      const attackSkills = convertAttackSkills({
        attackSkills: newData.attackSkills,
      });
      const rollString = convertRollString({
        rollString: newData.rollString,
      });
      putMartialAttack(
        newData.character_id,
        newData.name,
        newData.mpCount,
        attacks,
        attackSkills,
        rollString,
        newData.description,
        newData.id
      ).then((response) => {
        context.commit("addMartialAttack", {
          name: newData.name,
          mpCount: newData.mpCount,
          attacks: newData.attacks,
          attackSkills: newData.attackSkills,
          rollString: newData.rollString,
          description: newData.description,
          id: response.data[0].id,
        });
      });
    },
    loadAttackFromDB(
      context: any,
      newData: {
        characterId: string;
        id: number;
        name: string;
        mpCount: number;
        attacks: string;
        attackSkills: string;
        rollString: string;
        description: string;
      }
    ) {
      const attacks = convertAttacksBack(newData.attacks);
      const attackSkills = convertAttackSkillsBack(newData.attackSkills);
      const rollString = convertRollStringBack(newData.rollString);
      const attack = {
        id: newData.id,
        name: newData.name,
        mpCount: newData.mpCount,
        attacks: attacks,
        attackSkills: attackSkills,
        rollString: rollString,
        description: newData.description,
      };
      context.commit("addMartialAttack", attack);
    },
  },
};
